import type {SaveButtonText} from '../types';

export const LOG_ACTIVITY_BUTTON_TEXT: SaveButtonText = {
    buttonText: 'Log activity',
    savingText: 'Logging...',
    successText: 'Logged',
};
export const SCHEDULE_FOLLOW_UP_BUTTON_TEXT: SaveButtonText = {
    buttonText: 'Schedule follow-up',
    savingText: 'Scheduling...',
    successText: 'Scheduled',
};
export const CREATE_ACTIVITY_BUTTON_TEXT: SaveButtonText = {
    buttonText: 'Create activity',
    savingText: 'Creating...',
    successText: 'Created',
};
